




















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import KoejaksonVaiheHyvaksynnat from '@/components/koejakson-vaiheet/koejakson-vaihe-hyvaksynnat.vue'
import KoulutuspaikanArvioijat from '@/components/koejakson-vaiheet/koulutuspaikan-arvioijat.vue'
import { AloituskeskusteluLomake, KoejaksonVaiheHyvaksynta } from '@/types'
import * as hyvaksynnatHelper from '@/utils/koejaksonVaiheHyvaksyntaMapper'

@Component({
  components: {
    KoulutuspaikanArvioijat,
    KoejaksonVaiheHyvaksynnat
  }
})
export default class ArviointilomakeAloituskeskusteluReadonly extends Vue {
  @Prop({ required: true, default: {} })
  data!: AloituskeskusteluLomake

  get tyotunnitViikossa() {
    return this.data?.tyotunnitViikossa?.toString().replace('.', ',')
  }

  get hyvaksynnat(): KoejaksonVaiheHyvaksynta[] {
    const hyvaksyntaErikoistuva = hyvaksynnatHelper.mapHyvaksyntaErikoistuva(
      this,
      this.data.erikoistuvanNimi,
      this.data.erikoistuvanKuittausaika
    ) as KoejaksonVaiheHyvaksynta
    const hyvaksyntaLahikouluttaja = hyvaksynnatHelper.mapHyvaksyntaLahikouluttaja(
      this,
      this.data.lahikouluttaja
    )
    const hyvaksyntaLahiesimies = hyvaksynnatHelper.mapHyvaksyntaLahiesimies(
      this,
      this.data.lahiesimies
    )

    return [hyvaksyntaErikoistuva, hyvaksyntaLahikouluttaja, hyvaksyntaLahiesimies].filter(
      (a): a is KoejaksonVaiheHyvaksynta => a !== null
    )
  }
}
